export { boostrapEventListeners } from './boostrapEventListeners';
export { bootstrapCollapse } from './bootstrapCollapse';

import { boostrapEventListeners } from './boostrapEventListeners';
import { bootstrapCollapse } from './bootstrapCollapse';

if (typeof window !== 'undefined') {
    (window as any).h3b = {
        ...(window as any).h3b,
    };
    (window as any).h3b.blog = {
        ...(window as any).h3b.blog,
        boostrapEventListeners,
        bootstrapCollapse,
    };
}
